// Wallet detection helpers — works for MetaMask, Trust Wallet, TokenPocket,
// SafePal, MathWallet, Binance Wallet, and other injected EIP-1193 providers.

export const detectProvider = () => {
  if (typeof window === 'undefined') return null;
  return window.ethereum || window.BinanceChain || null;
};

export const isMobile = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const isTrustWallet = () => {
  if (typeof window === 'undefined') return false;
  const eth = window.ethereum;
  if (!eth) return false;
  return !!eth.isTrust || !!eth.isTrustWallet;
};

export const isMetaMask = () => {
  if (typeof window === 'undefined') return false;
  const eth = window.ethereum;
  if (!eth) return false;
  return !!eth.isMetaMask && !eth.isTrust && !eth.isTrustWallet;
};

export const isBinanceWallet = () => {
  if (typeof window === 'undefined') return false;
  return !!window.BinanceChain;
};

export const isInAnyDappBrowser = () => {
  return !!detectProvider();
};

export const detectedWallets = () => {
  const list = [];
  if (typeof window === 'undefined') return list;

  if (window.ethereum) {
    if (window.ethereum.providers && Array.isArray(window.ethereum.providers)) {
      window.ethereum.providers.forEach((p) => {
        if (p.isTrust || p.isTrustWallet) list.push({ key: 'trust', name: 'Trust Wallet', provider: p });
        else if (p.isMetaMask) list.push({ key: 'metamask', name: 'MetaMask', provider: p });
      });
    } else {
      if (window.ethereum.isTrust || window.ethereum.isTrustWallet) {
        list.push({ key: 'trust', name: 'Trust Wallet', provider: window.ethereum });
      } else if (window.ethereum.isMetaMask) {
        list.push({ key: 'metamask', name: 'MetaMask', provider: window.ethereum });
      } else {
        list.push({ key: 'injected', name: 'Browser Wallet', provider: window.ethereum });
      }
    }
  }

  if (window.BinanceChain && !list.find((w) => w.key === 'binance')) {
    list.push({ key: 'binance', name: 'Binance Wallet', provider: window.BinanceChain });
  }

  return list;
};

export const pickProvider = (key) => {
  if (typeof window === 'undefined') return null;
  if (key === 'binance' && window.BinanceChain) return window.BinanceChain;

  if (window.ethereum) {
    if (window.ethereum.providers && Array.isArray(window.ethereum.providers)) {
      if (key === 'trust') {
        return window.ethereum.providers.find((p) => p.isTrust || p.isTrustWallet) || window.ethereum;
      }
      if (key === 'metamask') {
        return window.ethereum.providers.find((p) => p.isMetaMask && !p.isTrust) || window.ethereum;
      }
    }
    return window.ethereum;
  }
  return null;
};

export const openTrustWalletDeepLink = () => {
  if (!isMobile()) return false;
  const url = window.location.href.replace(/^https?:\/\//, '');
  window.location.href = `https://link.trustwallet.com/open_url?coin_id=20000714&url=https://${url}`;
  return true;
};

export const openMetaMaskDeepLink = () => {
  if (!isMobile()) return false;
  const url = window.location.href.replace(/^https?:\/\//, '');
  window.location.href = `https://metamask.app.link/dapp/${url}`;
  return true;
};
